/**
 * initializeBlock
 *
 * Adds custom JavaScript to the block HTML.
 *
 * @author  Score Media (Sven van Hees)
 * @date    15/4/19
 * @since   1.0.0
 *
 * @param   object $block The block jQuery element.
 * @param   object attributes The block attributes (only available when editing).
 * @return  void
 */
var initializeBlock = function ( $block ) {

  // Find all selects
  $block.find('select').each(function(){
    $(this).on('change', function() {
      $('#vacancy_block_filter').submit();
    })
  });

  // Form submit handler.
  $block.find('#vacancy_block_filter').submit(function(){

    const btn = $(this).find( "button[type=submit]:focus" );
    const otherButtons = $(this).find( "button[type=submit]:not(:focus)" );

    otherButtons.removeClass('bg-ntp-yellow');
    btn.addClass('bg-ntp-yellow');

    $('#filter_value').val(btn.attr('data-location'))

    const filter = $(this);

    $.ajax({
      url : filter.attr('action'),
      data: filter.serialize(),
      type : 'POST',
    })
      .done(function(data) {
      $('#vacancies-container').html(data);
    });

    return false;
  });
}

// Initialize each block on page load (front end).
$(document).ready(function () {
  $('.open-vacancies-block').each(() => initializeBlock($(this)));
});

// Initialize dynamic block preview (editor).
if ( window.acf ) {
  window.acf.addAction('render_block_preview/type=slider', initializeBlock);
}
